export interface Moods{
    mood:number,
    moodJournal:string
}

export function MoodsDefaultvalues():Moods{
    return {mood:0,moodJournal:''}
}

export interface MoodViewModel{
    id:number,
    moodId:number,
    color:string
    moodJournal:string,
    createdDate:string,
    createdOnDate:string,
    showJournalIcon:boolean
}

export function MoodViewModelDefaultValues():MoodViewModel
{
    return {       
        id:0,
        moodId:0,
        color:'',
        moodJournal:'',
        createdDate:'',
        createdOnDate:'',
        showJournalIcon:false
    }
}

export type MoodDayStatus = 'skipped' | 'logged' | 'future';

export interface MoodCalendarDay {
    day: number;
    isPadding: boolean;
    status: MoodDayStatus;
    mood?: MoodViewModel;
    isToday: boolean;
    isFuture: boolean;
}